export default "__VITE_ASSET__CJDWuPUA__"